import Vue from 'vue'
import Router from 'vue-router'

import Layout from '../layout/Layout.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'

import SysUser from '../views/sys/User.vue'
import SysRole from '../views/sys/Role.vue'
import SysMenu from '../views/sys/Menu.vue'

import BizOrder from '../views/biz/Order.vue'
import BizAirport from '../views/biz/Airport.vue'
import BizPartner from '../views/biz/Partner.vue'
import BizAppUser from '../views/biz/AppUser.vue'
import BizTransportCompany from '../views/biz/TransportCompany.vue'

import { getToken } from '../utils/auth'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/login', component: Login },
    {
      path: '/',
      component: Layout,
      redirect: '/dashboard',
      children: [
        { path: 'dashboard', component: Dashboard, meta: { title: '首页' } },
        { path: 'sys/user', component: SysUser, meta: { title: '用户管理' } },
        { path: 'sys/role', component: SysRole, meta: { title: '角色管理' } },
        { path: 'sys/menu', component: SysMenu, meta: { title: '菜单管理' } },
        { path: 'biz/order', component: BizOrder, meta: { title: '订单管理' } },
        { path: 'biz/airport', component: BizAirport, meta: { title: '机场管理' } },
        { path: 'biz/partner', component: BizPartner, meta: { title: '合作商管理' } },
        { path: 'biz/transport-company', component: BizTransportCompany, meta: { title: '运输公司管理' } },
        { path: 'biz/app-user', component: BizAppUser, meta: { title: '小程序用户' } }
      ]
    }
  ]
})

router.beforeEach((to, _from, next) => {
  if (to.path === '/login') return next()
  const token = getToken()
  if (!token) return next('/login')
  next()
})

export default router
